import { combineReducers } from "redux";
import { loginReducer } from "./LoginReducer";
import { masterReducer } from "./masterReducers";

export const rootReducer = combineReducers({
    login: loginReducer,
    master: masterReducer,
})